/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useContext } from 'react';
import PropTypes from 'prop-types';

import Button from '~atoms/button';
import { prettyTracker, translate } from '~helpers/getters';
import { Context } from '~context/MainProvider';
import styles from './operator-cta.module.scss';

export default function OperatorCta({
  operator,
  placeholderText = 'Soon Available',
  closedCasinoText = 'Not Accepting New Players',
  playText = 'Visit',
  translationKey = 'play_now',
  tracker = 'main',
  gtmClass = '',
  tertiary = false,
  pageTemplate,
  icon,
}) {
  const { translations } = useContext(Context) || {};
  const status = operator?.status;
  const isPlaceHolder = status === 'coming_soon';
  const isClosed = status === 'inactive';
  const renderCta = () => {
    if (isPlaceHolder || isClosed) {
      const translateBtn = isPlaceHolder
        ? translate(translations, 'coming_soon', placeholderText)
        : translate(translations, 'closed_casino', closedCasinoText);

      return (
        <div
          title={translateBtn || ''}
          aria-label={translateBtn || ''}
          className={`${
            isPlaceHolder ? styles.operatorCtaPlaceholder : styles.operatorCtaClosed
          } ${gtmClass} operator-cta-gtm`}
        >
          {translateBtn}
        </div>
      );
    }

    const trackerType = tracker.toLowerCase().replace(' ', '_');
    const prettyLink = prettyTracker(operator, trackerType, false, pageTemplate);
    const translateBtn = translate(translations, translationKey, playText);
    return (
      <Button
        to={prettyLink || '#'}
        btnText={translateBtn}
        isInternalLink={false}
        gtmClass={`${gtmClass || ''} operator-cta-gtm btn-cta`}
        tertiary={tertiary}
        icon={icon}
      />
    );
  };

  return renderCta();
}

OperatorCta.propTypes = {
  operator: PropTypes.shape({
    name: PropTypes.string,
    status: PropTypes.string,
  }).isRequired,
  placeholderText: PropTypes.string,
  playText: PropTypes.string,
  closedCasinoText: PropTypes.string,
  gtmClass: PropTypes.string,
  icon: PropTypes.func,
};
